__turbopack_context__.v({
  "actions": "marketplace-chrome-module__i1x_8q__actions",
  "header": "marketplace-chrome-module__i1x_8q__header",
  "iconButton": "marketplace-chrome-module__i1x_8q__iconButton",
  "login": "marketplace-chrome-module__i1x_8q__login",
  "logoOnly": "marketplace-chrome-module__i1x_8q__logoOnly",
  "profile": "marketplace-chrome-module__i1x_8q__profile",
  "search": "marketplace-chrome-module__i1x_8q__search",
  "searchGlyph": "marketplace-chrome-module__i1x_8q__searchGlyph",
  "wordmark": "marketplace-chrome-module__i1x_8q__wordmark",
});
